import SettingTypes from '@/utils/setting-types'

export default {
  name: 'header',
  label: {
    title: '头部',
    icon: require('@/assets/icon-component-label_ShopInfo.png'),
    limit: 1
  },
  sort: 0,
  data: {
    // 显示内容
    show_content: 'SM',
    // 内容文本
    content_text: '永辉优选',
    // 文本颜色
    text_color: '#ffffff',
    // 背景颜色
    background_color: ''
  },
  settings: {
    show_content: {
      type: SettingTypes.select,
      label: '显示内容',
      options: [
        { label: '山姆', value: 'SM' },
        { label: '永辉', value: 'YH' }
      ]
    },
    content_text: {
      type: SettingTypes.input,
      label: '内容文本',
      default: '永辉优选',
      show: (data) => data.show_content === 'YH',
    },
    text_color: {
      type: SettingTypes.color_picker,
      label: '文本颜色',
      default: '#969799'
    },
    background_color: {
      type: SettingTypes.color_picker,
      label: '背景颜色',
      default: '#f9f9f9'
    }
  }
}
